import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import Porcentajes from '../complementos/Porcentajes';
import CustomPlayerImageWithDefault from '@/components/shared/custom/CustomPlayerImageWithDefault';
import Apercibidos from '../complementos/Apercibidos';
import useStatusIcon from '@/DesignSystem/hooks/useStatusIcon';
import useFantasySelected from '@/DesignSystem/hooks/useFantasySelected';
import { toPriceInEuros } from '@/helpers/prices-helper';
import JugadorAlineacionMercadoFantasy from '../complementos/JugadorAlineacionMercadoFantasy';
import { FANTASY } from '@/helpers/biwenger-helper';
import NoInscritoIcon from '@/components/shared/icons/recommendation-icons/no-inscrito-icon';
import useShowPlayerAlineacionProbable from '../hooks/useShowPlayerAlineacionProbable';

const JugadorPredictCard = memo(({ player, playerBoxWidth, showPercentage = true }) => {
    const { fantasy } = useFantasySelected();
    const handleShowPlayerAlineacionProbable = useShowPlayerAlineacionProbable(player);
    const statusIcon = useStatusIcon({
        status: player?.status,
        statusLevel: player?.statusLevel,
        width: 14,
        height: 14,
        skipIfNotOk: true,
    });

    const getPredictData = () => {
        if (
            fantasy === FANTASY.FANTASY ||
            fantasy === FANTASY.FANTASY_MARCA ||
            fantasy === FANTASY.BIWENGER ||
            fantasy === FANTASY.MISTER_FANTASY
        ) {
            let subida = player.laLigaFantasySubida;
            let marketValue = player.laLigaFantasyMarketValue;

            if (fantasy === FANTASY.FANTASY_MARCA) {
                subida = player.fantasyMarcaSubida;
                marketValue = player.fantasyMarcaMarketValue;
            } else if (fantasy === FANTASY.MISTER_FANTASY) {
                subida = player.misterFantasySubida;
                marketValue = player.misterFantasyMarketValue;
            } else if (fantasy === FANTASY.BIWENGER) {
                subida = player.biwengerSubida;
                marketValue = player.biwengerMarketValue;
            }

            return (
                <>
                    <JugadorAlineacionMercadoFantasy
                        value={subida}
                        width="90%"
                        height="15px"
                        margin={'5px auto 0 auto'}
                        maxWidth={'70px'}
                        fantasy={fantasy}
                    />
                    <Typography
                        fontSize={10}
                        color={'#ccc'}
                        margin={'2px auto 0 auto'}
                        width={'90%'}
                        textAlign={'center'}
                    >
                        {toPriceInEuros(marketValue)}
                    </Typography>
                </>
            );
        }
    };

    return (
        <Box
            sx={{
                width: '80px',
                display: 'flex',
                py: 1,
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: 1,
                transition: 'all 0.2s ease',
                position: 'relative',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                },
            }}
            onClick={handleShowPlayerAlineacionProbable}
        >
            {/* Imagen del jugador */}
            <Box sx={{ position: 'relative' }}>
                <Box sx={{ position: 'absolute', bottom: '-2px', left: 0 }}>{statusIcon}</Box>
                <CustomPlayerImageWithDefault playerId={player.id} alt={player.name} width={70} height={70} />

                {player.isNoInscrito && (
                    <Box sx={{ position: 'absolute', top: 0, left: 0 }}>
                        <NoInscritoIcon width={12} height={12} />
                    </Box>
                )}

                {showPercentage && (
                    <Porcentajes
                        porcentaje={player.chance}
                        fontSize={10}
                        width={'30px'}
                        height={'15px'}
                        position={'absolute'}
                        bottom={0}
                        right={0}
                    />
                )}
            </Box>
            {/* Nombre del jugador */}
            <Typography
                variant="body2"
                sx={{
                    textAlign: 'center',
                    fontWeight: 500,
                    fontSize: 12,
                    lineHeight: 1.2,
                    marginBottom: 0.5,
                    maxWidth: '90%',
                    margin: '0 5%',
                    position: 'relative',
                }}
                noWrap
            >
                {player.name}
            </Typography>
            <Apercibidos cards={player.cards} position="absolute" top={5} right={5} />

            {getPredictData()}
        </Box>
    );
});

export default JugadorPredictCard;
